import React from 'react';
import { connect } from 'react-redux';
import { selectEasyWalkThroughFormStep } from '../../../store/selectors/easyWalkThroughForm'
import ViewAllAreasAndFloorPlan from './ViewAllAreasAndFloorPlan';
import ViewSubAreas from './ViewSubAreas';
import DeveloperWalkthroughContainer from '../../../pages/DeveloperWalkthrough/DeveloperWalkthroughContainer';

const EasyWalkThroughFormSteps = ({ easyWalkThroughFormStep, ...props }) => {
  switch(easyWalkThroughFormStep) {
    case 0:
      return <ViewAllAreasAndFloorPlan {...props} />;
    case 1:
      return <ViewSubAreas {...props} />;
      case 3:
        return <DeveloperWalkthroughContainer {...props} />
    default:
      return null;
  }
};

const mapStateToProps = state => ({
  easyWalkThroughFormStep: selectEasyWalkThroughFormStep(state),
});

export default connect(mapStateToProps)(EasyWalkThroughFormSteps);
